<template>
  <div>
    <TitlePage :title="$t('edit')+' '+$t('review')"></TitlePage>

    <v-form @submit.prevent="update()" class="bb-gray pb-5" ref="form_edit" v-model="check">
      <v-layout wrap>

        <v-row>
          <v-col cols="12">
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                <tr>
                  <td>Utente</td>
                  <td><a :href="`/#/customers/edit/${item.user_id}`" target="_blank">{{ item.user_fullname }}</a></td>
                </tr>
                <tr>
                  <td>Voto</td>
                  <td>{{item.vote}}</td>
                </tr>
                <tr>
                  <td>Status</td>
                  <td>
                    <v-switch v-model="item.active" inset :readonly="!getUser.super_admin"></v-switch>
                  </td>
                </tr>
                <tr>
                  <td>Data creazione</td>
                  <td>{{new Date(item.created_at).toLocaleString()}}</td>
                </tr>
                <tr>
                  <td>Data ultimo aggiornamento</td>
                  <td>{{new Date(item.updated_at).toLocaleString()}}</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-col cols="12">
            <v-textarea name="content" filled label="Contenuto" auto-grow :value="item.content" :rules="[rules.required]" readonly></v-textarea>
          </v-col>
        </v-row>


        <v-flex md12 class="pt-10 d-flex">
          <v-divider class="marg-title"></v-divider>
        </v-flex>

        <v-flex md12 class="pt-5 d-flex buttons-group-mobile">
          <v-btn elevation="2" color="" class="mr-auto" @click="$router.go(-1)">
            <v-icon left>mdi-keyboard-backspace</v-icon>
            {{ $t('back') }}
          </v-btn>
          <v-btn elevation="2" color="primary" class="ml-auto" @click="update" type="submit" v-if="getUser.super_admin">
            {{ $t('save') }}
            <v-icon right>mdi-content-save</v-icon>
          </v-btn>
        </v-flex>

      </v-layout>

    </v-form>
  </div>
</template>

<script>
import TitlePage from "@/components/utils/TitlePage";
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  name: "EditReview",
  components: {TitlePage},
  data() {
    return {
      item: {
        status: false,
        content: ''
      },
      check: true,
      rules: {
        required: value => !!value || this.$t('fillMandatory'),
      },
    };
  },
  async created(){
    this.setLoading(true);
    var fetchItem = await this.editItem(this.$route.params)
    this.item = this._.clone(fetchItem.result)
    this.setLoading(false);
  },
  computed: {
    ...mapGetters({
      'getUser': 'user/getUser',
    }),
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),
    ...mapActions({
      'editItem': 'reviews/edit',
      'updateItem': 'reviews/update'
    }),
    async update(){

      this.$refs.form_edit.validate()
      if(!this.check){
        return
      }

      await this.setLoading(true);
      var result = await this.updateItem({...this.$route.params, item:this.item})
      await this.setLoading(false);

      if(result.success){

        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('updateSuccess')
        })

      }else {

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: result
        })

      }


    },

  },
  mounted() {

  },
}
</script>

<style scoped>

</style>